import { render, staticRenderFns } from "./DropdownToGoReward.vue?vue&type=template&id=c8d65418"
import script from "./DropdownToGoReward.vue?vue&type=script&lang=js"
export * from "./DropdownToGoReward.vue?vue&type=script&lang=js"
import style0 from "./DropdownToGoReward.vue?vue&type=style&index=0&id=c8d65418&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports